import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  IconButton,
  Tooltip,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import React, { useRef, useState } from "react";

import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { PF } from "../../../../config";

import LaunchIcon from "@mui/icons-material/Launch";

import { useDispatch, useSelector } from "react-redux";
import {
  getBlogs,
  removeBlog,
} from "../../../../reduxToolkit/features/adminPanel/blog";
import { getNotification } from "../../../../reduxToolkit/features/adminPanel/notification";
import LoadingButton from "@mui/lab/LoadingButton";
import { getCreated } from "../../../../hooks/getCreatedData";

import { makeUrlFriendly } from "../../../../hooks/makeUrlFriendly";
import { buildFrontendUrl } from "../../../../hooks/langAlias";
import { colors, fonts, radii, shadows } from "../../../../theme/designTokens";

export default function BlogCard({
  x,
  frontEnd,
  viewMode,
  setViewMode,
  setEditDlg,
  setEditBuffer,
  blogListEn,
  lang,
  fromHome,
}) {
  const dispatch = useDispatch();
  // const navigate = useNavigate();

  const blogRef = useRef();
  const [loading, setLoading] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const [openBlogDlg, setOpenBlogDlg] = useState(false);

  // Local Store
  const localAdminData = () => {
    let adminData = JSON.parse(localStorage.getItem("adminLoginInfo"));
    return adminData;
  };

  //   Store
  const { admins } = useSelector((state) => state.admin);

  const getEnInfo = (detectorId) => {
    let obj = {
      title: "",
    };
    const B = blogListEn.find((b) => b._id === detectorId);
    if (B) obj = { ...B };
    return obj;
  };

  const getCreatorName = (id) => {
    let name = "";
    const A = admins.find((a) => a._id === id);
    if (A) name = A.adminName;
    return name;
  };

  const handleRemoveBlog = () => {
    setLoading(true);
    if (localAdminData()._id)
      dispatch(
        removeBlog({
          _id: x._id,
          title: x.title,
          creatorId: localAdminData()._id,
        })
      );
    setTimeout(() => {
      dispatch(getNotification());
      dispatch(getBlogs());
      setLoading(false);
    }, 1000);
  };

  const handleBlogOpen = () => {
    if (fromHome) {
      setOpenBlogDlg(true);
    }
  };

  //! Translate
  // Store
  const { langArrFromClientSide } = useSelector((state) => state.misc);
  const translate0 = (String) => {
    let translation = "";
    if (langArrFromClientSide && langArrFromClientSide.length > 0) {
      const T = langArrFromClientSide.find((l) => l.title === String);
      if (T && T.value) {
        let obj = { ...T };
        if (T.value === "") obj.value = T.title;
        translation = T.value;
      } else if (T === undefined) translation = String;
    }
    return translation;
  };
  //! Translate

  //! Translate
  // Store
  const { langArrFromClientSideFrontend } = useSelector(
    (state) => state.miscFront
  );
  const translateFront = (String) => {
    let translation = "";
    if (
      langArrFromClientSideFrontend &&
      langArrFromClientSideFrontend.length > 0
    ) {
      const T = langArrFromClientSideFrontend.find((l) => l.title === String);
      if (T && T.value) {
        let obj = { ...T };
        if (T.value === "") obj.value = T.title;
        translation = T.value;
      } else if (T === undefined) translation = String;
    }
    return translation;
  };
  //! Translate
  return (
    <>
      {x && (
        <Card
          sx={
            frontEnd
              ? {
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  borderRadius: radii.lg,
                  boxShadow: shadows.card,
                  border: `1px solid ${colors.line}`,
                  overflow: "hidden",
                  transition: "box-shadow .15s ease, transform .15s ease",
                  "&:hover": { boxShadow: shadows.cardHover },
                }
              : {
                  height: fromHome ? 400 : "100%",
                  display: "flex",
                  flexDirection: "column",
                  borderRadius: radii.lg,
                  boxShadow: shadows.card,
                  border: `1px solid ${colors.line}`,
                }
          }
        >
          <Box ref={blogRef}></Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-end",
              height: frontEnd && fromHome ? 180 : 200,
              flexShrink: 0,
              bgcolor: colors.white,
              cursor: fromHome && "pointer",
            }}
            onClick={() => handleBlogOpen()}
          >
            <LazyLoadImage
              effect="blur"
              src={
                x.blogImg && x.blogImg !== ""
                  ? PF + "/adminPanel/blog/" + x.blogImg
                  : PF + "/adminPanel/medicines/no-medicine-image.jpg"
              }
              alt={x.title}
              style={{
                objectFit: "cover",
                width: "100%",
              }}
            />
          </Box>
          <CardContent
            sx={
              frontEnd
                ? { display: "flex", flexDirection: "column", flexGrow: 1, p: 2.75 }
                : { display: "flex", flexDirection: "column", flexGrow: 1 }
            }
          >
            {frontEnd && x.createdAt && (
              <Typography sx={{ fontSize: 12, color: colors.ink3, mb: 0.75 }}>
                {getCreated(x.createdAt)}
              </Typography>
            )}
            <Tooltip
              arrow
              placement="top-start"
              title={getEnInfo(x.blogDetectorId).title}
            >
              <Typography
                gutterBottom
                variant="h5"
                component="div"
                sx={
                  frontEnd
                    ? {
                        fontFamily: fonts.display,
                        fontWeight: 700,
                        fontSize: "1.05rem",
                        color: colors.ink,
                        lineHeight: 1.35,
                        minHeight: "2.7em",
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                      }
                    : undefined
                }
              >
                {x.title}
                {/* {lang !== "en" && mdUp && ( */}
                <IconButton
                  size="small"
                  onClick={() =>
                    window.open(
                      buildFrontendUrl(
                        lang,
                        `/blog/${makeUrlFriendly(
                          lang !== "en"
                            ? getEnInfo(x.blogDetectorId).title
                            : x.title
                        )}`
                      ),
                      "_blank"
                    )
                  }
                >
                  <LaunchIcon color="info" />
                </IconButton>
                {/* )} */}
              </Typography>
            </Tooltip>
            {!frontEnd && (
              <>
                <Typography variant="subtitle1" color="primary">
                  {translate0("Author")}:{" "}
                  {getCreatorName(x.creatorId).toUpperCase()}
                </Typography>
                <Typography variant="body2" sx={{ color: colors.ink3 }}>
                  {translate0("Published")}: {getCreated(x.createdAt)}
                </Typography>
                <Typography variant="body2" sx={{ color: colors.ink3 }}>
                  {translate0("Updated")}: {getCreated(x.updatedAt)}
                </Typography>
              </>
            )}
            <Typography
              variant="body2"
              color="text.secondary"
              sx={
                frontEnd
                  ? { flexGrow: 1, fontSize: 13.5, lineHeight: 1.55, color: colors.ink3 }
                  : undefined
              }
            >
              {frontEnd ? (
                <>
                  {showMore ? (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: `${x.content}`,
                      }}
                    ></div>
                  ) : (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: `${
                          x.content.length > 150
                            ? x.content.substring(0, 150) + "..."
                            : x.content
                        }`,
                      }}
                    ></div>
                  )}
                  {x.content.length > 150 && (
                    <Box
                      sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: fromHome ? "flex-start" : "flex-end",
                        mt: fromHome ? 1.75 : 0,
                      }}
                    >
                      {!fromHome && (
                        <Button
                          variant="contained"
                          size="small"
                          color={frontEnd ? undefined : "primary"}
                          sx={
                            frontEnd
                              ? {
                                  textTransform: "none",
                                  borderRadius: radii.md,
                                  bgcolor: `${colors.primary} !important`,
                                  color: "#fff !important",
                                  boxShadow: "none",
                                  "&:hover": { bgcolor: `${colors.primaryDark} !important`, boxShadow: "none" },
                                }
                              : undefined
                          }
                          onClick={() => {
                            setShowMore(!showMore);
                            let arr = [...viewMode];
                            if (!showMore) arr.push(x._id);
                            else arr = arr.filter((a) => a !== x._id);
                            setViewMode(arr);
                            setTimeout(
                              () =>
                                blogRef.current.scrollIntoView({
                                  behavior: "smooth",
                                }),
                              250
                            );
                          }}
                        >
                          {showMore
                            ? frontEnd
                              ? translateFront("Show Less")
                              : translate0("Show Less")
                            : frontEnd
                            ? translateFront("More")
                            : translate0("More")}
                        </Button>
                      )}
                      {fromHome && (
                        <Box
                          onClick={() => handleBlogOpen()}
                          sx={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 0.5,
                            fontSize: 13,
                            fontWeight: 700,
                            color: colors.primary,
                            cursor: "pointer",
                            "&:hover": { color: colors.primaryDark },
                          }}
                        >
                          Read More <LaunchIcon sx={{ fontSize: 14 }} />
                        </Box>
                      )}
                    </Box>
                  )}
                </>
              ) : (
                <>
                  <Box
                    sx={{
                      maxHeight: { xs: "40vh", sm: "20vh" },
                      overflowY: "auto",
                      overflowX: "hidden",
                    }}
                  >
                    <div
                      dangerouslySetInnerHTML={{
                        __html: `${x.content}`,
                      }}
                    ></div>
                  </Box>
                </>
              )}
            </Typography>
          </CardContent>
          {!frontEnd && (
            <CardActions sx={{ justifyContent: "flex-end" }}>
              <Button
                size="small"
                color="primary"
                onClick={() => {
                  setEditDlg(true);
                  setEditBuffer(x);
                }}
              >
                {translate0("Edit")}
              </Button>
              <LoadingButton
                loading={loading}
                size="small"
                color="error"
                onClick={handleRemoveBlog}
              >
                {translate0("Delete")}
              </LoadingButton>
            </CardActions>
          )}
        </Card>
      )}
      {openBlogDlg && (
        <Dialog open={openBlogDlg} aria-labelledby={"blog-dialog"}>
          <DialogTitle>
            <Typography gutterBottom variant="h5" component="div">
              {x.title}
            </Typography>
          </DialogTitle>
          <DialogContent>
            <div
              dangerouslySetInnerHTML={{
                __html: `${x.content}`,
              }}
            ></div>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenBlogDlg(false)} color="error">
              {translate0("Close")}
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}
